import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'myrtls-auth-callback',
    templateUrl: './callback.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinnerModule],
})
export class AuthCallbackComponent implements OnInit {
    constructor(
        private auth: AuthService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.auth.handleRedirectCallback().subscribe({
            next: result => {
                const target = result.appState?.target ?? '/';
                console.log('Navigating to target...', target);
                this.router.navigateByUrl(target);
            },
            error: () => {
                this.activatedRoute.queryParams.subscribe(params => {
                    console.log('Navigating to Error page with params...', {
                        error: params['error_description'],
                    });
                    this.router.navigate(['/auth/error'], {
                        queryParams: { error: params['error_description'] },
                    });
                });
            },
        });
    }
}
